import axios from 'axios';
import _ from 'lodash';
import api from './api';
import vlog from '../../vlog';

_.extend(api, {
  createMessage(userId, email, token, toSguid, subject, messageHtml, { videoRequest = false } = {}) {
    vlog.info('api#sendMessage');

    api.configure();

    const url = '/api/internal/messaging/messages';

    const headers = {
      'X-User-Email': email,
      'X-User-Token': token,
    };

    const data = {
      to: toSguid,
      user_id: userId,
      // video_request: intent stamp from the "Request a video" quick reply — V2 maps it into
      // message metadata so the recipient's record-video CTA survives any wording edits.
      message: { body: messageHtml, subject, video_request: !!videoRequest },
    };

    return axios.post(url, data, { headers });
  },

  createMessageV2(userId, toSguidArray, subject, messageHtml, fileArray) {
    vlog.info('api#sendMessage');

    api.configure();

    const url = '/api/internal/messaging/messages';

    const data = {
      to: toSguidArray,
      user_id: userId,
      message: {
        body: messageHtml,
        subject,
        attachments_attributes: fileArray,
      },
    };

    return axios.post(url, data);
  },

  followUpMessage(userId, email, token, toSguid, subject, messageHtml) {
    vlog.info('api#followUpMessage');

    api.configure();

    const url = '/api/internal/messaging/messages/follow_up';

    const headers = {
      'X-User-Email': email,
      'X-User-Token': token,
    };

    const data = {
      to: toSguid,
      user_id: userId,
      message: { body: messageHtml, subject },
    };

    return axios.post(url, data, { headers });
  },
});
